import { render } from "./email-verification-three.vue?vue&type=template&id=1f95d806"
import script from "./email-verification-three.vue?vue&type=script&lang=js"
export * from "./email-verification-three.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__